/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I paste FASTA?`)
};

const es_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo pegar FASTA?`)
};

const de_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich FASTA einfügen?`)
};

const nl_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik FASTA plakken?`)
};

const fr_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je coller du FASTA ?`)
};

const it_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso incollare FASTA?`)
};

const pt_br2_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso colar em FASTA?`)
};

const pt_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso colar FASTA?`)
};

const ja_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FASTAを貼り付けられますか？`)
};

const zh_revcomp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以粘贴 FASTA 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_q4", locale)
	if (locale === "en") return en_revcomp_faq_q4(inputs)
	if (locale === "es") return es_revcomp_faq_q4(inputs)
	if (locale === "de") return de_revcomp_faq_q4(inputs)
	if (locale === "nl") return nl_revcomp_faq_q4(inputs)
	if (locale === "fr") return fr_revcomp_faq_q4(inputs)
	if (locale === "it") return it_revcomp_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_q4(inputs)
	if (locale === "pt") return pt_revcomp_faq_q4(inputs)
	if (locale === "ja") return ja_revcomp_faq_q4(inputs)
	return zh_revcomp_faq_q4(inputs)
};